import { useContext, useEffect, useMemo } from "react";

import { useSearchParams } from "react-router-dom";
import { mainContext } from "../context";

export const usePredefinedQueryParams = () => {
  const [searchParams] = useSearchParams();
  const { setGeneralAppParams } = useContext(mainContext);

  useEffect(() => {
    setGeneralAppParams(searchParams.toString());
  }, [searchParams, setGeneralAppParams]);

  const predefinedParams = useMemo(() => {
    const companyId = searchParams.get("companyId");
    const companyName = searchParams.get("companyName");
    const locationId = searchParams.get("locationId");
    const locationName = searchParams.get("locationName");
    const sublocationId = searchParams.get("sublocationId");
    const sublocationName = searchParams.get("sublocationName");
    const customerId = searchParams.get("customerId");
    const customerName = searchParams.get("customerName");

    if (
      companyId &&
      companyName &&
      locationId &&
      locationName &&
      customerId &&
      customerName
    ) {
      return {
        company: {
          id: +companyId,
          name: companyName,
        },
        location: {
          id: +locationId,
          name: locationName,
        },
        customer: {
          id: +customerId,
          name: customerName,
        },

        ...(sublocationId &&
          sublocationName && {
            sublocation: {
              id: +sublocationId,
              name: sublocationName,
            },
          }),
      };
    }

    return null;
  }, [searchParams]);

  return {
    predefinedParams: predefinedParams,
    rawStringParams: searchParams.toString(),
  };
};
